"use client";

import { useIsEmbed } from "@calcom/embed-core/embed-iframe";
import { COMPANY_WEBSITE_URL } from "@calcom/lib/constants";
import { InviqonWordmark } from "@components/ui/InviqonWordmark";

/**
 * The company mark on the public surfaces - the booker, and the team and profile
 * pages. Those show whose calendar it is, which is right, but nothing that says
 * who is hosting it.
 *
 * Larger than the dashboard's mark, and pointing at the company site rather than
 * at the dashboard: the people who see this one are guests, and the dashboard is
 * not theirs to go to.
 *
 * Never inside an embed. The marketing site embeds the booker on its own page,
 * where a second mark under the first one would be wrong.
 *
 * The condition is deliberately `!== false` rather than a plain negation:
 * useIsEmbed starts undefined and resolves in an effect, so testing for a
 * confirmed false means an embed never flashes the mark before hiding it. The
 * cost is that it appears a beat late on ordinary pages, which is the better
 * side to be wrong on.
 */
export function PublicBrandHeader() {
  const isEmbed = useIsEmbed();
  if (isEmbed !== false) return null;

  return (
    <div className="pointer-events-none absolute top-0 left-0 z-10 p-6">
      <a
        href={COMPANY_WEBSITE_URL}
        target="_blank"
        rel="noreferrer"
        className="pointer-events-auto inline-block opacity-80 transition-opacity hover:opacity-100">
        <InviqonWordmark className="h-6" />
      </a>
    </div>
  );
}
